import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const ensureMetaTag = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('meta');
    Object.entries(attributes).forEach(([key, value]) => {
      element.setAttribute(key, value);
    });
    document.head.appendChild(element);
  }

  return element;
};

const ensureCanonicalTag = () => {
  let element = document.head.querySelector('link[rel="canonical"]');

  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'canonical');
    document.head.appendChild(element);
  }

  return element;
};

export const usePageSeo = (titleKey, descriptionKey) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const title = t(titleKey);
    const description = t(descriptionKey);
    const pagePath = window.location.pathname === '/home' ? '/' : window.location.pathname;
    const canonicalUrl = `https://www.vbcontrol.com${pagePath}`;

    document.title = title;
    document.documentElement.lang = (i18n.resolvedLanguage || i18n.language || 'nl').substring(0, 2);

    ensureMetaTag('meta[name="description"]', { name: 'description' }).setAttribute('content', description);
    ensureMetaTag('meta[property="og:title"]', { property: 'og:title' }).setAttribute('content', title);
    ensureMetaTag('meta[property="og:description"]', { property: 'og:description' }).setAttribute('content', description);
    ensureMetaTag('meta[property="og:url"]', { property: 'og:url' }).setAttribute('content', canonicalUrl);
    ensureMetaTag('meta[name="twitter:title"]', { name: 'twitter:title' }).setAttribute('content', title);
    ensureMetaTag('meta[name="twitter:description"]', { name: 'twitter:description' }).setAttribute('content', description);

    ensureCanonicalTag().setAttribute('href', canonicalUrl);
  }, [t, i18n, titleKey, descriptionKey]);
};
